import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function invoiceNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null; // Let required validator handle empty values
    }

    // Check if value matches YY01XXXXXX format (exactly 10 digits with positions 3-4 being "01")
    if (!/^\d{2}01\d{6}$/.test(value)) {
      return { invalidInvoiceFormat: true };
    }

    const year = parseInt(value.substring(0, 2), 10);
    const currentYear = new Date().getFullYear() % 100; // Get last 2 digits of current year

    // Check if year is not in the future
    if (year > currentYear) {
      return { invalidInvoiceFormat: true };
    }

    return null;
  };
}
